import { TLocation, ILocation } from 'shared/types/location';

export const getGeoSuggestLocation = (location: TLocation): number =>
  (location === 'moscow_mo' && -1) || (location === 'spb_lo' && -2) || (location as ILocation).id;
